type LegacyFileSystem = {
  EncodingType: { Base64: any };
  deleteAsync: (uri: string, options: { idempotent: boolean }) => Promise<void>;
  downloadAsync: (url: string, uri: string) => Promise<{ status: number }>;
  readAsStringAsync: (uri: string, options: { encoding: any }) => Promise<string>;
  writeAsStringAsync: (
    uri: string,
    content: string,
    options: { encoding: any },
  ) => Promise<void>;
};

export const downloadRemoteImageToFile = async (
  url: string,
  destinationUri: string,
  fileSystem: LegacyFileSystem,
): Promise<void> => {
  const temporaryUri =
    `${destinationUri}.download-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  try {
    const download = await fileSystem.downloadAsync(url, temporaryUri);
    if (download.status < 200 || download.status >= 300) {
      throw new Error(`HTTP ${download.status} ao baixar imagem`);
    }

    const base64 = await fileSystem.readAsStringAsync(temporaryUri, {
      encoding: fileSystem.EncodingType.Base64,
    });
    await fileSystem.writeAsStringAsync(destinationUri, base64, {
      encoding: fileSystem.EncodingType.Base64,
    });
  } finally {
    await fileSystem.deleteAsync(temporaryUri, { idempotent: true });
  }
};

export const downloadRemoteImageIOS = downloadRemoteImageToFile;
